import {NurseMeasurementType} from "../initiate-measurement/initiate-measurement-data";
import {ReleaseToggleState} from "../../tools/release-toggles/release-toggle-state";
import {isLimitedPositiveInteger} from "../validations";

export function isValidHeightOrWeightValue(
  value: any,
  measurementType: NurseMeasurementType | undefined,
  ecgTechnicianAnalysisOnlyEnabled: boolean
) {
  return (
    (
      (value === undefined || value === null || value === "")
      && measurementType !== undefined
      && isEcgMeasurement(measurementType!)
      &&
      (
        ReleaseToggleState.getInstance().isReleased("HEIGHT_AND_WEIGHT_NOT_MANDATORY_FOR_ECG_464")
        || ecgTechnicianAnalysisOnlyEnabled
      )
    )
    ||
    isLimitedPositiveInteger(300, value)
  );
}

function isEcgMeasurement(measurementType: NurseMeasurementType): boolean {
  return [
    "HOME_HOLTER_24H",
    "HOME_HOLTER_48H",
    "HOME_HOLTER_7D",
    "HOME_ECG_ATRIAL_FIBRILLATION",
    "HOME_SYMPTOM_HOLTER",
    "HOLTER_ECG",
    "ECG_ATRIAL_FIBRILLATION",
    "SYMPTOM_HOLTER"
  ].includes(measurementType);
}
